import { FC, useState } from 'react';
import styles from './BuyPanel.module.css';
import checkIcon from '../../img/check-mark.png'
import deliveryIcon from '../../img/delivery-icon.png'
import clockIcon from '../../img/clock-icon.png'
import paymentIcon from '../../img/payment-icon.png'
import { ProductProps } from './Types';
import buttonsStyles from '../../buttons.module.css';
import { addToCart } from '../../redux/cartSlice';
import { useCartDispatch } from '../../redux/storeCart';

const AvailableProductItem: FC<{ quantity: number, productId: number }> = ({ quantity, productId }) => {
    if (quantity)
        return (
            <div className={styles.item}>
                <span className={styles.ok}>Avaiable</span>
                <span><a href={"/available/" + productId}> Find out more</a></span>
            </div>
        );
    else
        return (
            <div className={styles.item}>
                <span className={styles.error}>Inaccessible</span>
                <span><a href="/inaccessible/1"> Find out more</a></span>
            </div>
        );
}

const DeliveryItem: FC<{ hasFreeDelivery: boolean }> = ({ hasFreeDelivery }) => {
    if (hasFreeDelivery) {
        return (
            <div className={styles.item}>
                <span className={styles.ok}>Free Delivery</span>
                <span><a href={"/deliveryfree"}> Find out more</a></span>
            </div>
        );
    } else {
        return (
            <div className={styles.item}>
                <span>Free pickup in the shop</span>
                <span><a href={"/delivery"}> Find out more</a></span>
            </div>
        )
    }
}

const LoanInstallmentItemDetailRow: FC<{ installmentPrice: number, productId: number }> = ({ installmentPrice, productId }) => {
    return (
        <div className={styles.detailRow}>
            <img src={paymentIcon} alt="icon" />
            <div className={styles.item}>
                <span>Installment only {installmentPrice} PLN</span>
                <span><a href={"/installment/" + productId}>Calculate loan rate</a></span>
            </div>
        </div>
    );
}

export const BuyPanel: FC<{ purchasedProduct: ProductProps }> = ({ purchasedProduct }) => {
    const [quantity, setQuantity] = useState(1);
    const dispatch = useCartDispatch();

    const onAddToCartBtnClick = (product: ProductProps) => {
        dispatch(addToCart({
            id: product.id,
            imageSrc: product.imageSrc,
            name: product.name,
            price: product.price,
            discountPrice: product.priceDiscount,
            quantity: quantity
        }))
    }

    const onQuntityChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        const inputValue = Number(e.target.value);
        setQuantity(inputValue > 0 ? inputValue : 1);
    }

    return (
        <div className={styles.buyPanel}>
            <span>Save {purchasedProduct.price - purchasedProduct.priceDiscount} pln</span>
            <div className={styles.totalPrice}>
                <del>{purchasedProduct.price} pln </del>
                <h2>{purchasedProduct.priceDiscount} pln</h2>
            </div>
            <div className={styles.addToCart}>
                <button className={buttonsStyles.btnPrimary} onClick={() => onAddToCartBtnClick(purchasedProduct)}>Add to cart</button>
                <input type='number' value={quantity} onChange={onQuntityChange}></input>
            </div>
            <div className={styles.details}>
                <hr />
                <div className={styles.detailRow}>
                    <img src={checkIcon} alt="icon" />
                    <AvailableProductItem quantity={purchasedProduct.quantity} productId={purchasedProduct.id} />
                </div>
                <hr />
                <div className={styles.detailRow}>
                    <img src={clockIcon} alt="icon" />
                    <div className={styles.item}>
                        <span>Buy now, receive day after tomorrow</span>
                        <span><a href={"/receiveday/" + purchasedProduct.id}>Find out more</a></span>
                    </div>
                </div>
                <hr />
                <div className={styles.detailRow}>
                    <img src={deliveryIcon} alt="icon" />
                    <DeliveryItem hasFreeDelivery={purchasedProduct.freeDelivery} />
                </div>
                <hr />
                {purchasedProduct.installmentPrice && <LoanInstallmentItemDetailRow installmentPrice={purchasedProduct.installmentPrice} productId={purchasedProduct.id} />}
            </div>
        </div>
    );
}